export enum EditableType {
  input = 1,
  select,
  date,
}
